<template>
  <div
    class="video-container"
    :id="content.key"
  >
    <div class="video-box" @click="videoPlayerShow">
      <img class="video-cover" :src="content.cover" alt="">
      <div class="video-btn">
        <span><i class="el-icon-caret-right icon"></i></span>
      </div>
    </div>
    <div class="video-title">{{ content.title }}</div>
    <videoPlayer :dialogTitle="dialogTitle" :visible="dialogVisible" :video_src="content.url" @dialogClose="videoPlayerHide"></videoPlayer>
  </div>
</template>

<script>
/*
单个视频样式 适用于每排两个显示版型
*/
import videoPlayer from "../../popup/videoPlayer.vue";
export default {
  name: "videoSmallUnit",
  components: {
    videoPlayer
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      dialogTitle: '播放视频',
      dialogVisible: false
    }
  },
  methods: {
    videoPlayerShow() {
      this.dialogVisible = true
    },
    videoPlayerHide() {
      this.dialogVisible = false
    },
  }
}
</script>

<style lang="scss" scoped>
.video-container {
  width: 340rem;
  height: 190rem;
  margin-bottom: 55rem;

  .video-box{
    width: 100%;
    position: relative;
    cursor: pointer;

    .video-cover{
      width: 100%;
      display: block;
    }

    .video-btn{
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background: rgba(93, 115, 120, .5);
      text-indent: 0;

      span {
        width: 52rem;
        height: 52rem;
        border-radius: 50%;
        background: #98E1E2;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        align-items: center;
        justify-content: center;


        .icon {
          font-size: 30rem;
          color: rgba(93, 115, 120, .6);
        }
      }
    }
  }
  
  .video-title{
    width: 100%;
    display: inline-block;
    margin-top: 10rem;
    color: #00A9AD;
    font-size: 16rem;
    text-align: center;
  }
}
</style>